/** Número de WhatsApp del negocio (configurable por variable de entorno). */
export const WHATSAPP_NUMBER =
  import.meta.env.VITE_WHATSAPP_NUMBER ?? "18092468383";

/** Construye una URL de WhatsApp con un mensaje precargado. */
export function buildWhatsAppUrl(
  text: string,
  phone: string = WHATSAPP_NUMBER
): string {
  const clean = phone.replace(/\D/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(text)}`;
}
